<template>
  <image class="flex size-10 cursor-pointer items-center justify-center rounded-full" @click="onClick">
    <img class="marker size-10" :src="icon" :alt="props.feature.properties?.['icon-name'] + ' icon'" />
  </image>
</template>

<script setup lang="ts">
import { HazardType, SelectedHazardViewType, useHazardsStore } from '@/features/hazards';
import { HAZARD_MARKERS } from '@/features/hazards/constants';
import { Feature, GeoJsonProperties, Geometry } from 'geojson';
import { Marker } from 'mapbox-gl';

const hazardsStore = useHazardsStore();

const props = defineProps<{
  marker: Marker;
  feature: Feature<Geometry, GeoJsonProperties>;
}>();

const icon = HAZARD_MARKERS[props.feature.properties?.['icon-name'] as keyof typeof HAZARD_MARKERS];

const onClick = async (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();

  const {
    id: hazardId,
    entityType: hazardType,
    eventId,
    featureId,
  } = props.feature.properties as { eventId: string; id: string; entityType: HazardType; featureId: string };

  hazardsStore.toggleSelectHazard({ hazardId, eventId, hazardType, featureId, viewType: SelectedHazardViewType.Popup });
};
</script>
